import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    getAdminBlocks({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-blocks`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAdminBlock({ commit }, { blockId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-blocks/${blockId}`)
          .then((res) => resolve(res.data.block))
          .catch((error) => reject(error))
      })
    },
    createAdminBlock({ commit }, block) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blocks`, block)
          .then((res) => resolve(res.data.block))
          .catch((error) => reject(error))
      })
    },
    createAdminBlockFromEditor({ commit }, block) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blocks-2`, block)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateAdminBlock({ commit }, block) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-blocks/${block.id}`, block)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createAgencyBlock({ commit }, agencyBlock) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/agency-blocks`, agencyBlock)
          .then((res) => resolve(res.data.agencyBlocks))
          .catch((error) => reject(error))
      })
    },
    updateAgencyBlock({ commit }, agencyBlock) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/agency-blocks/${agencyBlock.id}`, agencyBlock)
          .then((res) => resolve(res.data.agencyBlocks))
          .catch((error) => reject(error))
      })
    },
    adminPublishBlock({ commit }, blockId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blocks/${blockId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneBlock({ commit }, blockId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blocks/${blockId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    distributeForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/block-form/distribute`, params)
          .then((res) => resolve(res.data.form))
          .catch((error) => reject(error))
      })
    },
    deleteAdminBlock({ commit }, { blockId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-blocks/${blockId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteAgencyBlock({ commit }, { agencyBlockId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/agency-blocks/${agencyBlockId}`)
          .then((res) => resolve(res.data.agencyBlocks))
          .catch((error) => reject(error))
      })
    }
  },
  getters: {}
}